import { DunningsSitewideBanner } from "app/components/Dunnings/DunningsSitewideBanner/DunningsSitewideBanner";
import { ReactivateTrialDunningsSitewideBanner } from "app/components/Dunnings/ReactivateTrialDunningsSitewideBanner/ReactivateTrialDunningsSitewideBanner";
import { RestartTrialDunningsSitewideBanner } from "app/components/Dunnings/RestartTrialDunningsSitewideBanner/RestartTrialDunningsSitewideBanner";
import { useDunnings } from "app/components/hooks/useDunnings";

export const DunningsBanners = () => {
    const { isInRetryProcess, isAfterTrialDunningsWithTrial, isAfterTrialDunningsWithoutTrial } = useDunnings();

    if (isInRetryProcess) {
        return <DunningsSitewideBanner />;
    }

    if (isAfterTrialDunningsWithTrial) {
        return <RestartTrialDunningsSitewideBanner />;
    }

    if (isAfterTrialDunningsWithoutTrial) {
        return <ReactivateTrialDunningsSitewideBanner />;
    }
};
